const DiscordIcon = (props) => {
    return (
        <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.333 10C0.333 4.477 4.81 0 10.333 0C15.856 0 20.333 4.477 20.333 10C20.333 15.523 15.856 20 10.333 20C4.81 20 0.333 15.523 0.333 10ZM14.833 6.5C14.833 6.5 13.333 5.25 11.583 5.167L11.417 5.5C12.917 5.833 13.667 6.333 14.417 7C13.167 6.333 11.917 5.667 10.333 5.667C8.75 5.667 7.5 6.333 6.25 7C7 6.333 7.917 5.75 9.25 5.5L9.083 5.167C7.167 5.333 5.833 6.5 5.833 6.5C5.833 6.5 4.333 8.75 4.333 11.5C4.333 11.5 5.25 13.167 7.667 13.25C7.667 13.25 8.083 12.75 8.417 12.333C7.25 12 6.833 11.25 6.833 11.25C6.833 11.25 6.917 11.333 7.083 11.417C7.083 11.417 7.1 11.433 7.117 11.45C7.75 11.833 8.417 12.083 9.083 12.25C9.917 12.5 10.917 12.5 11.583 12.25C12.25 12.083 12.917 11.833 13.55 11.45C13.717 11.333 13.833 11.25 13.833 11.25C13.833 11.25 13.417 12 12.25 12.333C12.583 12.75 13 13.25 13 13.25C15.417 13.167 16.333 11.5 16.333 11.5C16.333 8.75 14.833 6.5 14.833 6.5ZM8.583 10.75C8.083 10.75 7.667 10.292 7.667 9.75C7.667 9.208 8.083 8.75 8.583 8.75C9.083 8.75 9.5 9.208 9.5 9.75C9.5 10.292 9.083 10.75 8.583 10.75ZM12.083 10.75C11.583 10.75 11.167 10.292 11.167 9.75C11.167 9.208 11.583 8.75 12.083 8.75C12.583 8.75 13 9.208 13 9.75C13 10.292 12.583 10.75 12.083 10.75Z"
                fill="white"
            />
        </svg>
    );
};

export default DiscordIcon;
